import i18n from '@/locales/index'
export default [
  {
    type: 'input',
    placeholder: `${i18n.t('Common.account')}/${i18n.t('Common.name')}`,
    filed: 'queryText',
    default: ''
  },
  {
    type: 'input',
    placeholder: i18n.t('Common.ip'),
    filed: 'ip',
    default: ''
  },
  {
    type: 'datepicker',
    placeholder: '',
    default: [],
    filed: 'daterange',
    params: {
      start: 'startTime',
      end: 'endTime'
    }
  }
]
